import { render, staticRenderFns } from "./OnboardingCreate.vue?vue&type=template&id=17202186&"
import script from "./OnboardingCreate.vue?vue&type=script&lang=js&"
export * from "./OnboardingCreate.vue?vue&type=script&lang=js&"
import style0 from "./OnboardingCreate.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports